import { render, staticRenderFns } from "./tenantBasic.vue?vue&type=template&id=2f42eeaf&scoped=true&"
import script from "./tenantBasic.vue?vue&type=script&lang=js&"
export * from "./tenantBasic.vue?vue&type=script&lang=js&"
import style0 from "./tenantBasic.vue?vue&type=style&index=0&id=2f42eeaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f42eeaf",
  null
  
)

export default component.exports